module.exports = __webpack_public_path__ + "img/ca.05b1c9ce.svg";